<template>
  <div>
    <div class="row row-space-10">
      <!-- begin col-3 -->
      <div class="col-lg-3 col-md-6">
        <div class="widget widget-stats bg-gradient-teal m-b-10">
          <div class="stats-icon stats-icon-lg">
            <i class="fas fa-user-graduate fa-fw"></i>
          </div>
          <div class="stats-content">
            <div class="stats-title">
              {{ $t('dashboardcomponents.totalStudents') }}
            </div>
            <div class="stats-number">{{ student.total }}</div>
            <div class="stats-progress progress">
              <div
                v-tooltip="student.percentages + '%'"
                class="progress-bar"
                :style="{ width: student.percentages + '%' }"
              ></div>
            </div>
            <div class="stats-desc">
              {{ $t('dashboardcomponents.female') }} ({{ student.female }})
            </div>
          </div>
        </div>
      </div>
      <!-- end col-3 -->
      <!-- begin col-3 -->
      <div class="col-lg-3 col-md-6">
        <div class="widget widget-stats bg-gradient-blue m-b-10">
          <div class="stats-icon stats-icon-lg">
            <i class="fas fa-user-tie fa-fw"></i>
          </div>
          <div class="stats-content">
            <div class="stats-title">
              {{ $t('dashboardcomponents.totalTeachers') }}
            </div>
            <div class="stats-number">{{ teacher.total }}</div>
            <div class="stats-progress progress">
              <div
                v-tooltip="teacher.percentages + '%'"
                class="progress-bar"
                :style="{ width: teacher.percentages + '%' }"
              ></div>
            </div>
            <div class="stats-desc">
              {{ $t('dashboardcomponents.female') }} ({{ teacher.female }})
            </div>
          </div>
        </div>
      </div>
      <!-- end col-3 -->
      <!-- begin col-3 -->
      <div class="col-lg-3 col-md-6">
        <div class="widget widget-stats bg-gradient-purple m-b-10">
          <div class="stats-icon stats-icon-lg">
            <i class="fas fa-users fa-fw"></i>
          </div>
          <div class="stats-content">
            <div class="stats-title">
              {{ $t('dashboardcomponents.totalParents') }}
            </div>
            <div class="stats-number">{{ parent.total }}</div>
            <div class="stats-progress progress">
              <div
                v-tooltip="parent.percentages + '%'"
                class="progress-bar"
                :style="{ width: parent.percentages + '%' }"
              ></div>
            </div>
            <div class="stats-desc">
              {{ $t('dashboardcomponents.usedApp') }}({{ parent.usedApp }})
            </div>
          </div>
        </div>
      </div>
      <!-- end col-3 -->
      <!-- begin col-3 -->
      <div class="col-lg-3 col-md-6">
        <div class="widget widget-stats bg-gradient-black m-b-10">
          <div class="stats-icon stats-icon-lg">
            <i class="fas fa-chalkboard-teacher fa-fw"></i>
          </div>
          <div class="stats-content">
            <div class="stats-title">
              {{ $t('dashboardcomponents.totalClasses') }}
            </div>
            <div class="stats-number">{{ classe.total }}</div>
            <div class="stats-progress progress">
              <div
                v-tooltip="classe.percentages + '%'"
                class="progress-bar"
                :style="{ width: classe.percentages + '%' }"
              ></div>
            </div>
            <div class="stats-desc">
              {{ $t('dashboardcomponents.currentClasses') }} ({{
                classe.current
              }})
            </div>
          </div>
        </div>
      </div>
      <!-- end col-3 -->
    </div>
    <!-- end row -->
  </div>
</template>
<script>
export default {
  name: 'totalCard',
  data() {
    return {
      loading: false,
      students: null,
      teachers: null,
      parents: null,
      classes: null
    }
  },
  created() {
    this.fetchTotal()
  },
  computed: {
    student() {
      if (this.students) {
        return this.students
      }
      return 0
    },
    teacher() {
      if (this.teachers) {
        return this.teachers
      }
      return 0
    },
    parent() {
      if (this.parents) {
        return this.parents
      }
      return 0
    },
    classe() {
      if (this.classes) {
        return this.classes
      }
      return 0
    }
  },
  methods: {
    fetchTotal() {
      this.$store
        .dispatch('dashboard/fetchTotal')
        .then(responses => {
          this.students = responses.students
          this.teachers = responses.teachers
          this.parents = responses.parents
          this.classes = responses.classes
          this.loading = false
        })
        .catch(() => {
          this.loading = false
        })
    }
  }
}
</script>
